import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/lib/api';
import { TriggerBuildRequest } from '@/types/deployment';
import toast from 'react-hot-toast';

interface TriggerBuildParams {
  projectId: string;
  data: TriggerBuildRequest;
}

async function triggerBuild({ projectId, data }: TriggerBuildParams): Promise<{ deployment: any }> {
  const response = await api.post<{ data: any }>(`/projects/${projectId}/builds`, data);
  // Backend returns { data: {...} }, but we need { deployment: {...} } for compatibility
  return { deployment: response.data.data };
}

export function useTriggerBuild() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: triggerBuild,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['deployments', variables.projectId] });
      toast.success('Build triggered successfully!');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to trigger build');
    },
  });
}
